import React from "react"
import styled, {keyframes} from "styled-components";

const Logos = () => {
    return (
        <LogosSection>
            <LogosLabel>Spolupracoval jsem s</LogosLabel>
            <LogoStrip>
                <Logo><img src="/img/logos/nextap.svg" alt="Nextap"/></Logo>
                <Logo><img src="/img/logos/tchk.svg" alt="Technologické centrum HK" style={{maxHeight: '3.5em'}}/></Logo>
                <Logo><img src="/img/logos/lg.svg" alt="Laser Game HK"/></Logo>
                <Logo><img src="/img/logos/steller.svg" alt="Steller" style={{maxHeight: '2.5em'}}/></Logo>
                <Logo><img src="/img/logos/dami.svg" alt="DAMI"/></Logo>
                <Logo><img src="/img/logos/zsbcuo.png" alt="ZŠ Bratří Čapků"/></Logo>
                <Logo><img src="/img/logos/logo_muuo_znak.png" alt="Město Ústí nad Orlicí"/></Logo>
                <Logo><img src="/img/logos/paiwand.png" alt="Paiwand"/></Logo>
            </LogoStrip>
        </LogosSection>
    )
}

export default Logos

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const LogosSection = styled.div`
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  padding: 3em 0;
  margin-bottom: 6em;
  animation: ${fadeUp} 0.5s ease both;
  animation-delay: 0.5s;
`

const LogosLabel = styled.div`
  text-align: center;
  font-size: 0.75em;
  font-weight: 400;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.5;
  margin-bottom: 2em;
`

const LogoStrip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2em 3em;
`

const Logo = styled.div`
  transition: opacity 0.2s ease;

  img {
    max-height: 2.8em;
    filter: grayscale(100%);
    opacity: 0.4;
    vertical-align: middle;
    transition: opacity 0.25s ease;
  }

  &:hover img {
    opacity: 0.7;
  }
`
